<!-- Link to PDF -->
<div class="centerLinkInDiv">
	<a class="pdrButton" href="/assets/terms_of_use.pdf">Get PDF</a>
</div>

<div class="pdfContainer">
    <embed class="pdfViewer" src="/assets/terms_of_use.pdf">
</div>